import { Confidence } from '../lib/db';

interface Props {
  value: Confidence | null;
  onChange: (c: Confidence) => void;
}

const options: Array<{ value: Confidence; label: string; emoji: string; color: string }> = [
  { value: 'lost', label: 'Lost', emoji: '🌀', color: 'bg-coral/15 text-coral ring-coral' },
  { value: 'sorta', label: 'Sorta', emoji: '🤔', color: 'bg-sun/20 text-ink ring-sun' },
  { value: 'got_it', label: 'Got it!', emoji: '✨', color: 'bg-sky/15 text-sky ring-sky' },
];

export default function ConfidenceButtons({ value, onChange }: Props) {
  return (
    <div className="card p-5 space-y-3">
      <div className="font-display text-lg">How'd that feel?</div>
      <div className="grid grid-cols-3 gap-3">
        {options.map((o) => {
          const active = value === o.value;
          return (
            <button
              key={o.value}
              onClick={() => onChange(o.value)}
              className={`${o.color} rounded-2xl py-4 font-semibold transition ring-2 ${
                active ? 'ring-offset-2 scale-105' : 'ring-transparent'
              }`}
            >
              <div className="text-2xl mb-1">{o.emoji}</div>
              <div>{o.label}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
